import axios from 'axios';
import { RequestPostShareDashboardPassword, ResponsePostShareDashboardPassword } from './types';
import { API_URL, API_VERSION } from '@/config';

const publicHttp = axios.create();

publicHttp.defaults.baseURL = `${API_URL}`;

publicHttp.defaults.headers.common['Content-Type'] = 'application/json';
publicHttp.defaults.headers.common['Accept'] = 'application/json';
publicHttp.defaults.headers.common['Access-Control-Allow-Origin'] = ['*'];

const version = API_VERSION;

export const postShareDashboardPassword = async (req: RequestPostShareDashboardPassword) => {
    return publicHttp
        .post<RequestPostShareDashboardPassword, ResponsePostShareDashboardPassword>(
            `/tenant/${req.tenantName}/${version}/dashboard/sharing/${req.externalId}`,
            {
                password: req.password,
            }
        )
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Error posting share dashboard password:', error);
            throw error;
        });
};
